/**
 * Recognising an approval link.
 *
 * Pure and separately tested, because getting this wrong has two bad shapes:
 * a customer meeting a sign-in screen, or the app disappearing behind an
 * approval page for a path that merely looked like one.
 */

/** Links look like `/a/<token>`. Returns the token, or null for any other path. */
export function approvalToken(pathname: string): string | null {
  const match = /^\/a\/([A-Za-z0-9_-]{8,128})\/?$/.exec(pathname);
  return match ? match[1]! : null;
}
